'use strict';

import {isMobile, isNoMenu} from '../../../settings';
import { BaseElement } from '../../interfaces/BaseElement';

export class Fullscreen {
  static element = document.documentElement;
  static scopes = [];

  constructor () {}

  addBtn(parent,additionalClass) {
    if (isNoMenu)
      return;

    if (!Fullscreen.active) return this;
    this.btn = new BaseElement('button')
      .addClass('fullscreen-btn','icon-fullscreen-arrows','background-backdrop-filter')
      .appendTo(parent)
      .event('click', Fullscreen.handler);

    if (additionalClass) {
      this.btn.addClass(additionalClass);
    }

    this.updateState();
    Fullscreen.scopes.push(this);

    return this;
  }

  updateState() {
    if (Fullscreen.enabled) {
      this.btn.removeClass('icon-fullscreen-arrows');
      this.btn.addClass('icon-fullscreen-arrows-2');
    } else {
      this.btn.removeClass('icon-fullscreen-arrows-2');
      this.btn.addClass('icon-fullscreen-arrows');
    }
  }

  dispose() {
    Fullscreen.scopes = Fullscreen.scopes.filter(btn => btn !== this);
  }

  set visibility(state) {
    switch (state) {
      case 'hide':
        this.btn.addClass('hidden');
        break;
      case 'show':
        this.btn.removeClass('hidden');
        break;
    }
  }

  static get active() {
    return isMobile && document.fullscreenEnabled;
  }

  static get enabled() {
    return document.fullscreenElement;
  }

  static handler() {
    if (Fullscreen.enabled) {
      Fullscreen.#close()
        .then(() => Fullscreen.updateButtonsState());
    } else {
      Fullscreen.#open()
        .then(() => Fullscreen.updateButtonsState());
    }
  }

  static visibilityToggle(state) {
    if (!Fullscreen.active) return;
    Fullscreen.scopes.forEach(btn => btn.visibility = state);
  }

  static updateButtonsState() {
    if (!Fullscreen.active) return;
    Fullscreen.scopes.forEach(btn => btn.updateState());
  }

  static #open() {
    return new Promise(resolve => {
      if (Fullscreen.element.requestFullscreen) {
        Fullscreen.element.requestFullscreen()
          .then(() => resolve());
      } else if (Fullscreen.element.mozRequestFullScreen) {
        Fullscreen.element.mozRequestFullScreen()
          .then(() => resolve());
      } else if (Fullscreen.element.webkitRequestFullscreen) {
        Fullscreen.element.webkitRequestFullscreen()
          .then(() => resolve());
      } else if (Fullscreen.element.msRequestFullscreen) {
        Fullscreen.element.msRequestFullscreen()
          .then(() => resolve());
      }
    });
  }

  static #close() {
    return new Promise(resolve => {
      if (document.exitFullscreen) {
        document.exitFullscreen()
          .then(() => resolve());
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
          .then(() => resolve());
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
          .then(() => resolve());
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
          .then(() => resolve());
      }
    });
  }
}
